import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import ButtonLink from '@components/common/Button/ButtonLink'
import { usePageSetup } from '@/hooks/usePageSetup'
import { organizationSchema, websiteSchema, softwareApplicationSchema } from '@/seo/schema'

import CalculatorVisual from '@assets/visuals/calculator.webp'
import EarnVisual from '@assets/visuals/earn.webp'
import SavingsVisual from '@assets/visuals/savings.webp'

import Slides, { Slide } from '@/components/common/Slides/Slides'

export const WelcomePage = () => {
  const { t } = useTranslation()

  const uspSlides: Slide[] = [
    {
      image: CalculatorVisual,
      title: t('welcome.slide1Title'),
      description: t('welcome.slide1Description')
    },
    {
      image: SavingsVisual,
      title: t('welcome.slide2Title'),
      description: t('welcome.slide2Description')
    },
    {
      image: EarnVisual,
      title: t('welcome.slide3Title'),
      description: t('welcome.slide3Description')
    }
  ]

  usePageSetup(t('welcome.pageTitle'), {
    scroll: true,
    canonical: '/',
    jsonLd: [organizationSchema(), websiteSchema(), softwareApplicationSchema()],
  })

  return (
    <div className="h-full bg-white p-5 pt-8 pb-5 flex flex-col">
      <h1 className="sr-only">Finhudas – apskaitos ir mokesčių programa pavežėjams (Bolt, Uber)</h1>
      <Slides
        slides={uspSlides}
        duration={5000}
        className='flex-1'
      />
      <motion.div className="flex flex-col gap-2"
        initial={{ y: "4rem" }}
        animate={{ y: 0 }}
        exit={{ y: "4rem" }}
        transition={{
          duration: 0.2,
          ease: "easeInOut"
        }}
      >
        <ButtonLink to={'/users/register'}>
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 0.2,
              ease: "easeInOut"
            }}
          >
            {t('welcome.createAccount')}
          </motion.span>
        </ButtonLink>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.2,
            ease: "easeInOut"
          }}
        >
          <ButtonLink to={'/users/login'} variant='secondary'>
            {t('common.login')}
          </ButtonLink>
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.2,
            delay: 0.1,
            ease: "easeInOut"
          }}
          className="text-center"
        >
          <Link to="/blog" className="text-xs text-zinc-600 hover:text-zinc-900 transition-colors underline">
            {t('welcome.readGuide')}
          </Link>
        </motion.div>
      </motion.div>
    </div>
  )
}

export default WelcomePage
